import React, { useEffect } from 'react';
import SiteLink from 'components/shared/sitelink/sitelink';
import Image from 'components/shared/image';
import RichText from 'components/shared/richtext';
import richTextEmbedTypes from 'lib/utils/richTextEmbedtypes';
import { addLocaleToHref } from 'lib/utils/helpers';
import { useRouter } from 'next/router';
import styles from './blogArticle.module.scss';

const BlogArticle = ({ data, locale }) => {
  const {
    category,
    socials,
    title,
    blogBody,
    headlineImage,
    collaborator,
    resources: { collaborator: collaboratiorResources },
  } = data;

  const router = useRouter();

  useEffect(() => {
    if (window.location.hash) {
      const id = decodeURI(window.location.hash);

      const anchorTarget = document.getElementById(id.replace('#', ''));

      if (anchorTarget) {
        window.location.href = id; // changing the url
        anchorTarget.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        }); // scrolling to section
      }
    }
  }, []);

  return (
    <section id="sectionBlogArticle" className={styles.sectionBlogArticle}>
      <p className={styles.articleCategory}>{category}</p>
      <h1 className={styles.articleTitle}>{title}</h1>
      {collaborator && (
        <div className={styles.collaboratorHead}>
          <span className={styles.collaboratorLabel}>
            {collaboratiorResources?.blogCollaboratorLabel?.text}
          </span>
          <div className={styles.collaboratorAvatar}>
            <Image src={collaborator?.avatar} layout="responsive" loading="lazy" />
          </div>
          <div className={styles.collaboratorInfo}>
            <SiteLink
              className={styles.collaboratorTitle}
              locale={locale}
              href={addLocaleToHref(collaborator?.slug, locale, router)}
            >
              {collaborator?.title}
            </SiteLink>
            <p className={styles.collaboratorSubtitle}>{collaborator?.subtitle}</p>
          </div>
        </div>
      )}
      <div className={styles.socialsWrapper}>
        {socials.map(social => (
          <SiteLink className={styles.socialIcon} external={`${social?.link}`}>
            <Image src={social?.socialIcon} layout="responsive" loading="lazy" />
          </SiteLink>
        ))}
      </div>
      <div className={styles.headlineImage}>
        <Image src={headlineImage.image} layout="fill" loading="eager" priority />
      </div>
      <div className={styles.blogArticleWrapper}>
        <RichText
          className={styles.blogBody}
          text={blogBody?.json}
          links={blogBody?.links}
          imagesResponsive
          embeddedClasses={{
            [richTextEmbedTypes.EMBEDDED_ASSETS.IMAGE]: styles.inlineImage,
            [richTextEmbedTypes.EMBEDDED_ENTRIES.COMPONENT_MEDIA.VIDEO]: styles.inlineVideo,
            [richTextEmbedTypes.EMBEDDED_ENTRIES.COMPONENT_MEDIA.IMAGE]: styles.inlineImage,
          }}
        />
      </div>
    </section>
  );
};

export default BlogArticle;
